import { Link } from 'react-router-dom';
import type { Topic } from '@/mocks/gossip';

interface TopicCardProps {
  topic: Topic;
  showRank?: number;
}

export default function TopicCard({ topic, showRank }: TopicCardProps) {
  return (
    <article className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden flex flex-col hover:border-primary-300 transition-colors">
      <Link to={`/topic/${topic.id}`} className="block relative w-full h-48 overflow-hidden">
        <img
          src={topic.cover}
          alt={`${topic.title} - 福利吃瓜话题配图`}
          title={`${topic.title} 福利吃瓜`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs text-primary-700 font-medium">
          {topic.category}
        </span>
        {typeof showRank === 'number' && (
          <span
            className={`absolute top-3 right-3 w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold ${
              showRank <= 3 ? 'bg-accent-500 text-foreground-950' : 'bg-background-50/90 text-foreground-800'
            }`}
          >
            {showRank}
          </span>
        )}
      </Link>

      <div className="p-4 md:p-5 flex flex-col flex-1">
        <h3 className="font-heading text-lg md:text-xl text-foreground-950 leading-snug">
          <Link to={`/topic/${topic.id}`} className="hover:text-primary-600 transition-colors">
            {topic.title}
          </Link>
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{topic.excerpt}</p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {topic.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs">
              #{tag}
            </span>
          ))}
        </div>

        <div className="mt-auto pt-4 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-3-line"></i>
            {topic.author}
          </span>
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {topic.readCount.toLocaleString()}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line"></i>
              {topic.commentCount}
            </span>
          </span>
        </div>
      </div>
    </article>
  );
}